<template>
  <div id="app-shell">
    <svg class="liquid-glass-defs" aria-hidden="true" focusable="false">
      <defs>
        <filter id="liquid-glass-filter" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            baseFrequency="0.012 0.018"
            numOctaves="2"
            result="liquidNoise"
            seed="8"
            type="fractalNoise"
          />
          <feGaussianBlur in="liquidNoise" result="softNoise" stdDeviation="1.6" />
          <feDisplacementMap
            in="SourceGraphic"
            in2="softNoise"
            scale="16"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
